import React from 'react';
import './RankingDisclaimer.css';

/**
 * RankingDisclaimer component displays a disclaimer about the accuracy of rankings
 */
function RankingDisclaimer() {
  return (
    <div className="ranking-disclaimer">
      <p>
        There is not enough publicly available information to determine final rankings. 
        This will give a rough estimate. Players must play but are not required to be 
        ranked in all games.
      </p>
    </div>
  );
}

export default RankingDisclaimer;